function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var H = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var t = function t(l, C, e) {
  return C in l ? H(l, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : l[C] = e;
},
    n = function n(l, C) {
  for (var e in C || (C = {})) {
    r.call(C, e) && t(l, e, C[e]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        d.call(C, e) && t(l, e, C[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return l;
};

import * as i from "react";

function v(l) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, l), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38882 6.99302C7.38882 8.43106 8.5629 9.60384 10.0025 9.60384C11.4422 9.60384 12.6023 8.43106 12.6023 6.99302C12.6023 5.55497 11.4422 4.39616 10.0025 4.39616C8.5629 4.39616 7.38882 5.55497 7.38882 6.99302ZM6.10292 6.07155C6.52224 4.31239 8.11563 3 10.0025 3C12.2109 3 14 4.78709 14 6.99302C14 9.19895 12.2109 11 10.0025 11C8.08767 11 6.4803 9.64572 6.08895 7.85864H3.89454C3.39136 7.85864 3 7.45375 3 6.9651C3 6.47644 3.39136 6.07155 3.89454 6.07155H6.10292ZM8.15939 16H3.84061C3.37623 16 3 16.4479 3 17.0008C3 17.5536 3.37623 18 3.84061 18H8.15939C8.62377 18 9 17.5536 9 17.0008C9 16.4479 8.62377 16 8.15939 16ZM14.9975 14.3962C16.4371 14.3962 17.6112 15.5689 17.6112 17.007C17.6112 18.445 16.4371 19.6038 14.9975 19.6038C13.5578 19.6038 12.3977 18.445 12.3977 17.007C12.3977 15.5689 13.5578 14.3962 14.9975 14.3962ZM18.8971 17.9284H21.1055C21.6086 17.9284 22 17.5236 22 17.0349C22 16.5462 21.6086 16.1414 21.1055 16.1414H18.9111C18.5197 14.3543 16.9123 13 14.9975 13C12.7891 13 11 14.801 11 17.007C11 19.2129 12.7891 21 14.9975 21C16.8844 21 18.4778 19.6876 18.8971 17.9284ZM16.8393 8H21.1594C21.6238 8 22 7.55208 22 6.99922C22 6.44636 21.6238 6 21.1594 6H16.8393C16.3762 6 16 6.44636 16 6.99922C16 7.55208 16.3762 8 16.8393 8Z",
    fill: "black"
  }));
}

export { v as ReactComponent };